import { render, staticRenderFns } from "./first-pay.vue?vue&type=template&id=924612d4"
import script from "./first-pay.vue?vue&type=script&lang=js"
export * from "./first-pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports